// This icon file is generated automatically.
var DrrpRepomgrIconOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 40 40", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M37.53 0H20.34c-.38 0-.8.18-1.08.47L.49 19.27l-.04.01a1.48 1.48 0 000 2.11L17.6 38.54l.02.03a1.5 1.5 0 002.12 0l18.81-18.82c.3-.3.47-.67.47-1.08V1.5c0-.83-.66-1.5-1.5-1.5zm-1.51 18.05L18.68 35.38 3.62 20.35 20.98 2.99h15.04v15.06zm-6.43-4.11a4.5 4.5 0 004.48-4.5 4.5 4.5 0 10-4.48 4.5zm0-7.18a2.68 2.68 0 012.68 2.69c0 1.48-1.22 2.7-2.68 2.7a2.7 2.7 0 110-5.39z", "fill-rule": "nonzero" } }] }, "name": "drrp-repomgr-icon", "theme": "outlined" };
export default DrrpRepomgrIconOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/DrrpRepomgrIconOutlined.js
// module id = 2570
// module chunks = 0